import { render } from "./CourseForm.vue?vue&type=template&id=7a9e1ea2&scoped=true"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"

import "./CourseForm.vue?vue&type=style&index=0&id=7a9e1ea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9e1ea2"]])

export default __exports__